export const lookupMappings = {
    ht_calltoaction: {
        "Ask a Product Question": "7c2a855e-18db-eb11-bacb-000d3a1177b2",
        "Contact Sales": "2382fc6e-18db-eb11-bacb-000d3a1177b2",
        "Content Download": "6e1a4175-18db-eb11-bacb-000d3a1177b2",
        "Demonstration": "90ad27f7-9b20-ec11-b6e6-00224822e5cd",
        "Event Registration": "6667397b-18db-eb11-bacb-000d3a1177b2",
        "Factory certified pre-owned": "a707a994-f1d4-ee11-9079-0022482b653c",
        "General Question": "4d482c9b-9d62-ec11-8f8f-000d3a15a78b",
        "Mailing List Sign Up": "a042d204-1fdb-eb11-bacb-000d3a1177b2",
        "Request a Demo": "a7c1af0b-1fdb-eb11-bacb-000d3a1177b2",
        "Request A Quote": "b31d1812-1fdb-eb11-bacb-000d3a1177b2",
        "Request an Assessment": "71d50052-1fdb-eb11-bacb-000d3a1177b2",
        "Request Free Trial": "d8bd3458-1fdb-eb11-bacb-000d3a1177b2",
        "Watch OnDemand Video/Webinar": "f2bd3458-1fdb-eb11-bacb-000d3a1177b2",
        "Where to Buy Inquiry": "05e22b62-1fdb-eb11-bacb-000d3a1177b2"
    },
    ht_preferredcommunicationlanguage: {
        "zh": "eea9742f-8afa-eb11-94ef-002248237d68",
        "nl": "09d05c1c-eecd-ee11-9079-0022481f6ec8",
        "en": "349a3929-8afa-eb11-94ef-002248237d68",
        "fr": "734cc436-8afa-eb11-94ef-002248237d68",
        "de": "f0a9742f-8afa-eb11-94ef-002248237d68",
        "id": "834cfd0e-72cf-ee11-9079-0022482b6bcf",
        "it": "09daf349-8afa-eb11-94ef-002248237d68",
        "ja": "4347ad50-8afa-eb11-94ef-002248237d68",
        "ko": "5147ad50-8afa-eb11-94ef-002248237d68",
        "pl": "f1f81b3d-8afa-eb11-94ef-002248237d68",
        "pt": "eec9b843-8afa-eb11-94ef-002248237d68",
        "ro": "8cb806e6-c0bb-ef11-b8e8-7c1e5266f876",
        "ru": "0c1ced56-8afa-eb11-94ef-002248237d68",
        "es": "e4f81b3d-8afa-eb11-94ef-002248237d68",
        "zh-Hant": "8ee2f0f6-71cf-ee11-9079-0022482b6bcf",
        "tr": "15daf349-8afa-eb11-94ef-002248237d68"
    },
    ht_countryisolookup: {
        "AF": "9d378388-63de-eb11-bacb-000d3a1adfe0",
        "AX": "9f378388-63de-eb11-bacb-000d3a1adfe0",
        "AL": "a1378388-63de-eb11-bacb-000d3a1adfe0",
        "DZ": "a3378388-63de-eb11-bacb-000d3a1adfe0",
        "AS": "a5378388-63de-eb11-bacb-000d3a1adfe0",
        "AD": "a7378388-63de-eb11-bacb-000d3a1adfe0",
        "AO": "a9378388-63de-eb11-bacb-000d3a1adfe0",
        "AI": "ab378388-63de-eb11-bacb-000d3a1adfe0",
        "AQ": "ad378388-63de-eb11-bacb-000d3a1adfe0",
        "AG": "af378388-63de-eb11-bacb-000d3a1adfe0",
        "AR": "b1378388-63de-eb11-bacb-000d3a1adfe0",
        "AM": "b3378388-63de-eb11-bacb-000d3a1adfe0",
        "AW": "b5378388-63de-eb11-bacb-000d3a1adfe0",
        "AU": "b7378388-63de-eb11-bacb-000d3a1adfe0",
        "AT": "b9378388-63de-eb11-bacb-000d3a1adfe0",
        "AZ": "bb378388-63de-eb11-bacb-000d3a1adfe0",
        "BS": "bd378388-63de-eb11-bacb-000d3a1adfe0",
        "BH": "bf378388-63de-eb11-bacb-000d3a1adfe0",
        "BD": "c1378388-63de-eb11-bacb-000d3a1adfe0",
        "BB": "c3378388-63de-eb11-bacb-000d3a1adfe0",
        "BY": "c5378388-63de-eb11-bacb-000d3a1adfe0",
        "BE": "c7378388-63de-eb11-bacb-000d3a1adfe0",
        "BZ": "c9378388-63de-eb11-bacb-000d3a1adfe0",
        "BJ": "cb378388-63de-eb11-bacb-000d3a1adfe0",
        "BM": "cd378388-63de-eb11-bacb-000d3a1adfe0",
        "BT": "cf378388-63de-eb11-bacb-000d3a1adfe0",
        "BO": "d1378388-63de-eb11-bacb-000d3a1adfe0",
        "BA": "d3378388-63de-eb11-bacb-000d3a1adfe0",
        "BW": "d5378388-63de-eb11-bacb-000d3a1adfe0",
        "BV": "d7378388-63de-eb11-bacb-000d3a1adfe0",
        "BR": "d9378388-63de-eb11-bacb-000d3a1adfe0",
        "IO": "db378388-63de-eb11-bacb-000d3a1adfe0",
        "BN": "dd378388-63de-eb11-bacb-000d3a1adfe0",
        "BG": "df378388-63de-eb11-bacb-000d3a1adfe0",
        "BF": "e1378388-63de-eb11-bacb-000d3a1adfe0",
        "BI": "e3378388-63de-eb11-bacb-000d3a1adfe0",
        "KH": "e5378388-63de-eb11-bacb-000d3a1adfe0",
        "CM": "e7378388-63de-eb11-bacb-000d3a1adfe0",
        "CA": "e9378388-63de-eb11-bacb-000d3a1adfe0",
        "CV": "eb378388-63de-eb11-bacb-000d3a1adfe0",
        "KY": "ed378388-63de-eb11-bacb-000d3a1adfe0",
        "CF": "ef378388-63de-eb11-bacb-000d3a1adfe0",
        "TD": "f1378388-63de-eb11-bacb-000d3a1adfe0",
        "CL": "f3378388-63de-eb11-bacb-000d3a1adfe0",
        "CN": "f5378388-63de-eb11-bacb-000d3a1adfe0",
        "CX": "f7378388-63de-eb11-bacb-000d3a1adfe0",
        "CC": "f9378388-63de-eb11-bacb-000d3a1adfe0",
        "CO": "fb378388-63de-eb11-bacb-000d3a1adfe0",
        "KM": "fd378388-63de-eb11-bacb-000d3a1adfe0",
        "CG": "ff378388-63de-eb11-bacb-000d3a1adfe0",
        "CD": "01388388-63de-eb11-bacb-000d3a1adfe0",
        "CK": "03388388-63de-eb11-bacb-000d3a1adfe0",
        "CR": "05388388-63de-eb11-bacb-000d3a1adfe0",
        "CI": "07388388-63de-eb11-bacb-000d3a1adfe0",
        "HR": "09388388-63de-eb11-bacb-000d3a1adfe0",
        "CU": "0b388388-63de-eb11-bacb-000d3a1adfe0",
        "CW": "0d388388-63de-eb11-bacb-000d3a1adfe0",
        "CY": "0f388388-63de-eb11-bacb-000d3a1adfe0",
        "CZ": "11388388-63de-eb11-bacb-000d3a1adfe0",
        "DK": "13388388-63de-eb11-bacb-000d3a1adfe0",
        "DJ": "15388388-63de-eb11-bacb-000d3a1adfe0",
        "DM": "17388388-63de-eb11-bacb-000d3a1adfe0",
        "DO": "19388388-63de-eb11-bacb-000d3a1adfe0",
        "EC": "1b388388-63de-eb11-bacb-000d3a1adfe0",
        "EG": "1d388388-63de-eb11-bacb-000d3a1adfe0",
        "SV": "1f388388-63de-eb11-bacb-000d3a1adfe0",
        "GQ": "21388388-63de-eb11-bacb-000d3a1adfe0",
        "ER": "23388388-63de-eb11-bacb-000d3a1adfe0",
        "EE": "25388388-63de-eb11-bacb-000d3a1adfe0",
        "ET": "27388388-63de-eb11-bacb-000d3a1adfe0",
        "FK": "29388388-63de-eb11-bacb-000d3a1adfe0",
        "FO": "2b388388-63de-eb11-bacb-000d3a1adfe0",
        "FJ": "2d388388-63de-eb11-bacb-000d3a1adfe0",
        "FI": "2f388388-63de-eb11-bacb-000d3a1adfe0",
        "FR": "31388388-63de-eb11-bacb-000d3a1adfe0",
        "GF": "33388388-63de-eb11-bacb-000d3a1adfe0",
        "PF": "35388388-63de-eb11-bacb-000d3a1adfe0",
        "TF": "37388388-63de-eb11-bacb-000d3a1adfe0",
        "GA": "39388388-63de-eb11-bacb-000d3a1adfe0",
        "GM": "3b388388-63de-eb11-bacb-000d3a1adfe0",
        "GE": "3d388388-63de-eb11-bacb-000d3a1adfe0",
        "DE": "3f388388-63de-eb11-bacb-000d3a1adfe0",
        "GH": "41388388-63de-eb11-bacb-000d3a1adfe0",
        "GI": "43388388-63de-eb11-bacb-000d3a1adfe0",
        "GR": "47388388-63de-eb11-bacb-000d3a1adfe0",
        "GL": "49388388-63de-eb11-bacb-000d3a1adfe0",
        "GD": "4b388388-63de-eb11-bacb-000d3a1adfe0",
        "GP": "4d388388-63de-eb11-bacb-000d3a1adfe0",
        "GU": "4f388388-63de-eb11-bacb-000d3a1adfe0",
        "GT": "51388388-63de-eb11-bacb-000d3a1adfe0",
        "GN": "53388388-63de-eb11-bacb-000d3a1adfe0",
        "GW": "55388388-63de-eb11-bacb-000d3a1adfe0",
        "GY": "57388388-63de-eb11-bacb-000d3a1adfe0",
        "HT": "59388388-63de-eb11-bacb-000d3a1adfe0",
        "HM": "5b388388-63de-eb11-bacb-000d3a1adfe0",
        "HN": "5d388388-63de-eb11-bacb-000d3a1adfe0",
        "HK": "5f388388-63de-eb11-bacb-000d3a1adfe0",
        "HU": "61388388-63de-eb11-bacb-000d3a1adfe0",
        "IS": "63388388-63de-eb11-bacb-000d3a1adfe0",
        "IN": "65388388-63de-eb11-bacb-000d3a1adfe0",
        "ID": "67388388-63de-eb11-bacb-000d3a1adfe0",
        "IR": "69388388-63de-eb11-bacb-000d3a1adfe0",
        "IQ": "6b388388-63de-eb11-bacb-000d3a1adfe0",
        "IE": "6d388388-63de-eb11-bacb-000d3a1adfe0",
        "IM": "6f388388-63de-eb11-bacb-000d3a1adfe0",
        "IL": "71388388-63de-eb11-bacb-000d3a1adfe0",
        "IT": "73388388-63de-eb11-bacb-000d3a1adfe0",
        "JM": "75388388-63de-eb11-bacb-000d3a1adfe0",
        "JP": "77388388-63de-eb11-bacb-000d3a1adfe0",
        "JE": "79388388-63de-eb11-bacb-000d3a1adfe0",
        "JO": "7b388388-63de-eb11-bacb-000d3a1adfe0",
        "KZ": "7d388388-63de-eb11-bacb-000d3a1adfe0",
        "KE": "7f388388-63de-eb11-bacb-000d3a1adfe0",
        "KI": "81388388-63de-eb11-bacb-000d3a1adfe0",
        "KP": "83388388-63de-eb11-bacb-000d3a1adfe0",
        "KR": "85388388-63de-eb11-bacb-000d3a1adfe0",
        "XK": "87388388-63de-eb11-bacb-000d3a1adfe0",
        "KW": "89388388-63de-eb11-bacb-000d3a1adfe0",
        "KG": "8b388388-63de-eb11-bacb-000d3a1adfe0",
        "LA": "8d388388-63de-eb11-bacb-000d3a1adfe0",
        "LV": "8f388388-63de-eb11-bacb-000d3a1adfe0",
        "LB": "91388388-63de-eb11-bacb-000d3a1adfe0",
        "LS": "93388388-63de-eb11-bacb-000d3a1adfe0",
        "LR": "95388388-63de-eb11-bacb-000d3a1adfe0",
        "LY": "97388388-63de-eb11-bacb-000d3a1adfe0",
        "LI": "99388388-63de-eb11-bacb-000d3a1adfe0",
        "LT": "9b388388-63de-eb11-bacb-000d3a1adfe0",
        "LU": "9d388388-63de-eb11-bacb-000d3a1adfe0",
        "MO": "9f388388-63de-eb11-bacb-000d3a1adfe0",
        "MG": "a3388388-63de-eb11-bacb-000d3a1adfe0",
        "MW": "a5388388-63de-eb11-bacb-000d3a1adfe0",
        "MY": "a7388388-63de-eb11-bacb-000d3a1adfe0",
        "MV": "a9388388-63de-eb11-bacb-000d3a1adfe0",
        "ML": "ab388388-63de-eb11-bacb-000d3a1adfe0",
        "MT": "ad388388-63de-eb11-bacb-000d3a1adfe0",
        "MH": "af388388-63de-eb11-bacb-000d3a1adfe0",
        "MQ": "b1388388-63de-eb11-bacb-000d3a1adfe0",
        "MR": "b3388388-63de-eb11-bacb-000d3a1adfe0",
        "MU": "b5388388-63de-eb11-bacb-000d3a1adfe0",
        "YT": "b7388388-63de-eb11-bacb-000d3a1adfe0",
        "MX": "b9388388-63de-eb11-bacb-000d3a1adfe0",
        "FM": "bb388388-63de-eb11-bacb-000d3a1adfe0",
        "MD": "bd388388-63de-eb11-bacb-000d3a1adfe0",
        "MC": "bf388388-63de-eb11-bacb-000d3a1adfe0",
        "MN": "c1388388-63de-eb11-bacb-000d3a1adfe0",
        "ME": "c3388388-63de-eb11-bacb-000d3a1adfe0",
        "MS": "c5388388-63de-eb11-bacb-000d3a1adfe0",
        "MA": "c7388388-63de-eb11-bacb-000d3a1adfe0",
        "MZ": "c9388388-63de-eb11-bacb-000d3a1adfe0",
        "MM": "cb388388-63de-eb11-bacb-000d3a1adfe0",
        "MP": "cd388388-63de-eb11-bacb-000d3a1adfe0",
        "NA": "cf388388-63de-eb11-bacb-000d3a1adfe0",
        "NR": "d1388388-63de-eb11-bacb-000d3a1adfe0",
        "NP": "d3388388-63de-eb11-bacb-000d3a1adfe0",
        "NL": "d5388388-63de-eb11-bacb-000d3a1adfe0",
        "AN": "d7388388-63de-eb11-bacb-000d3a1adfe0",
        "NC": "d9388388-63de-eb11-bacb-000d3a1adfe0",
        "NZ": "db388388-63de-eb11-bacb-000d3a1adfe0",
        "NI": "dd388388-63de-eb11-bacb-000d3a1adfe0",
        "NE": "df388388-63de-eb11-bacb-000d3a1adfe0",
        "NG": "e1388388-63de-eb11-bacb-000d3a1adfe0",
        "NU": "e3388388-63de-eb11-bacb-000d3a1adfe0",
        "NF": "e5388388-63de-eb11-bacb-000d3a1adfe0",
        "MK": "a1388388-63de-eb11-bacb-000d3a1adfe0",
        "NO": "e7388388-63de-eb11-bacb-000d3a1adfe0",
        "OM": "e9388388-63de-eb11-bacb-000d3a1adfe0",
        "PK": "eb388388-63de-eb11-bacb-000d3a1adfe0",
        "PW": "ed388388-63de-eb11-bacb-000d3a1adfe0",
        "PS": "ef388388-63de-eb11-bacb-000d3a1adfe0",
        "PA": "f1388388-63de-eb11-bacb-000d3a1adfe0",
        "PG": "f3388388-63de-eb11-bacb-000d3a1adfe0",
        "PY": "f5388388-63de-eb11-bacb-000d3a1adfe0",
        "PE": "f7388388-63de-eb11-bacb-000d3a1adfe0",
        "PH": "f9388388-63de-eb11-bacb-000d3a1adfe0",
        "PN": "fb388388-63de-eb11-bacb-000d3a1adfe0",
        "PL": "fd388388-63de-eb11-bacb-000d3a1adfe0",
        "PT": "ff388388-63de-eb11-bacb-000d3a1adfe0",
        "PR": "01398388-63de-eb11-bacb-000d3a1adfe0",
        "QA": "03398388-63de-eb11-bacb-000d3a1adfe0",
        "RE": "05398388-63de-eb11-bacb-000d3a1adfe0",
        "RO": "07398388-63de-eb11-bacb-000d3a1adfe0",
        "RU": "09398388-63de-eb11-bacb-000d3a1adfe0",
        "RW": "0b398388-63de-eb11-bacb-000d3a1adfe0",
        "BL": "0d398388-63de-eb11-bacb-000d3a1adfe0",
        "KN": "0f398388-63de-eb11-bacb-000d3a1adfe0",
        "LC": "11398388-63de-eb11-bacb-000d3a1adfe0",
        "MF": "13398388-63de-eb11-bacb-000d3a1adfe0",
        "WS": "15398388-63de-eb11-bacb-000d3a1adfe0",
        "SM": "17398388-63de-eb11-bacb-000d3a1adfe0",
        "ST": "19398388-63de-eb11-bacb-000d3a1adfe0",
        "SA": "1b398388-63de-eb11-bacb-000d3a1adfe0",
        "SN": "1d398388-63de-eb11-bacb-000d3a1adfe0",
        "RS": "1f398388-63de-eb11-bacb-000d3a1adfe0",
        "SC": "21398388-63de-eb11-bacb-000d3a1adfe0",
        "SL": "23398388-63de-eb11-bacb-000d3a1adfe0",
        "SG": "25398388-63de-eb11-bacb-000d3a1adfe0",
        "SX": "27398388-63de-eb11-bacb-000d3a1adfe0",
        "SK": "29398388-63de-eb11-bacb-000d3a1adfe0",
        "SI": "2b398388-63de-eb11-bacb-000d3a1adfe0",
        "SB": "2d398388-63de-eb11-bacb-000d3a1adfe0",
        "SO": "2f398388-63de-eb11-bacb-000d3a1adfe0",
        "ZA": "31398388-63de-eb11-bacb-000d3a1adfe0",
        "ES": "33398388-63de-eb11-bacb-000d3a1adfe0",
        "LK": "35398388-63de-eb11-bacb-000d3a1adfe0",
        "SH": "37398388-63de-eb11-bacb-000d3a1adfe0",
        "PM": "39398388-63de-eb11-bacb-000d3a1adfe0",
        "VC": "3b398388-63de-eb11-bacb-000d3a1adfe0",
        "SD": "3d398388-63de-eb11-bacb-000d3a1adfe0",
        "SR": "3f398388-63de-eb11-bacb-000d3a1adfe0",
        "SJ": "41398388-63de-eb11-bacb-000d3a1adfe0",
        "SZ": "43398388-63de-eb11-bacb-000d3a1adfe0",
        "SE": "45398388-63de-eb11-bacb-000d3a1adfe0",
        "CH": "47398388-63de-eb11-bacb-000d3a1adfe0",
        "SY": "49398388-63de-eb11-bacb-000d3a1adfe0",
        "TW": "4b398388-63de-eb11-bacb-000d3a1adfe0",
        "TJ": "4d398388-63de-eb11-bacb-000d3a1adfe0",
        "TZ": "4f398388-63de-eb11-bacb-000d3a1adfe0",
        "TH": "51398388-63de-eb11-bacb-000d3a1adfe0",
        "TL": "53398388-63de-eb11-bacb-000d3a1adfe0",
        "TG": "55398388-63de-eb11-bacb-000d3a1adfe0",
        "TK": "57398388-63de-eb11-bacb-000d3a1adfe0",
        "TO": "59398388-63de-eb11-bacb-000d3a1adfe0",
        "TT": "5b398388-63de-eb11-bacb-000d3a1adfe0",
        "TN": "5d398388-63de-eb11-bacb-000d3a1adfe0",
        "TR": "5f398388-63de-eb11-bacb-000d3a1adfe0",
        "TM": "61398388-63de-eb11-bacb-000d3a1adfe0",
        "TC": "63398388-63de-eb11-bacb-000d3a1adfe0",
        "TV": "65398388-63de-eb11-bacb-000d3a1adfe0",
        "UG": "67398388-63de-eb11-bacb-000d3a1adfe0",
        "UA": "69398388-63de-eb11-bacb-000d3a1adfe0",
        "AE": "6b398388-63de-eb11-bacb-000d3a1adfe0",
        "GB": "45388388-63de-eb11-bacb-000d3a1adfe0",
        "US": "6d398388-63de-eb11-bacb-000d3a1adfe0",
        "UY": "71398388-63de-eb11-bacb-000d3a1adfe0",
        "UM": "6f398388-63de-eb11-bacb-000d3a1adfe0",
        "UZ": "73398388-63de-eb11-bacb-000d3a1adfe0",
        "VU": "75398388-63de-eb11-bacb-000d3a1adfe0",
        "VA": "77398388-63de-eb11-bacb-000d3a1adfe0",
        "VE": "79398388-63de-eb11-bacb-000d3a1adfe0",
        "VN": "7b398388-63de-eb11-bacb-000d3a1adfe0",
        "VG": "7d398388-63de-eb11-bacb-000d3a1adfe0",
        "VI": "7f398388-63de-eb11-bacb-000d3a1adfe0",
        "WF": "81398388-63de-eb11-bacb-000d3a1adfe0",
        "EH": "83398388-63de-eb11-bacb-000d3a1adfe0",
        "YE": "85398388-63de-eb11-bacb-000d3a1adfe0",
        "ZM": "87398388-63de-eb11-bacb-000d3a1adfe0",
        "ZW": "89398388-63de-eb11-bacb-000d3a1adfe0"
    },
    us: {
        "AL": "b6f2b237-db17-ec11-b6e5-000d3a1c2943",
        "AK": "b8f2b237-db17-ec11-b6e5-000d3a1c2943",
        "AS": "baf2b237-db17-ec11-b6e5-000d3a1c2943",
        "AZ": "bcf2b237-db17-ec11-b6e5-000d3a1c2943",
        "AR": "bef2b237-db17-ec11-b6e5-000d3a1c2943",
        "CA": "c0f2b237-db17-ec11-b6e5-000d3a1c2943",
        "CO": "c2f2b237-db17-ec11-b6e5-000d3a1c2943",
        "CT": "c4f2b237-db17-ec11-b6e5-000d3a1c2943",
        "DE": "c6f2b237-db17-ec11-b6e5-000d3a1c2943",
        "DC": "c8f2b237-db17-ec11-b6e5-000d3a1c2943",
        "FL": "caf2b237-db17-ec11-b6e5-000d3a1c2943",
        "GA": "ccf2b237-db17-ec11-b6e5-000d3a1c2943",
        "GU": "cef2b237-db17-ec11-b6e5-000d3a1c2943",
        "HI": "d0f2b237-db17-ec11-b6e5-000d3a1c2943",
        "ID": "d2f2b237-db17-ec11-b6e5-000d3a1c2943",
        "IL": "d4f2b237-db17-ec11-b6e5-000d3a1c2943",
        "IN": "d6f2b237-db17-ec11-b6e5-000d3a1c2943",
        "IA": "d8f2b237-db17-ec11-b6e5-000d3a1c2943",
        "KS": "daf2b237-db17-ec11-b6e5-000d3a1c2943",
        "KY": "dcf2b237-db17-ec11-b6e5-000d3a1c2943",
        "LA": "def2b237-db17-ec11-b6e5-000d3a1c2943",
        "ME": "e0f2b237-db17-ec11-b6e5-000d3a1c2943",
        "MD": "e2f2b237-db17-ec11-b6e5-000d3a1c2943",
        "MA": "e4f2b237-db17-ec11-b6e5-000d3a1c2943",
        "MI": "e6f2b237-db17-ec11-b6e5-000d3a1c2943",
        "MN": "e8f2b237-db17-ec11-b6e5-000d3a1c2943",
        "MS": "eaf2b237-db17-ec11-b6e5-000d3a1c2943",
        "MO": "ecf2b237-db17-ec11-b6e5-000d3a1c2943",
        "MT": "eef2b237-db17-ec11-b6e5-000d3a1c2943",
        "NE": "f0f2b237-db17-ec11-b6e5-000d3a1c2943",
        "NV": "f2f2b237-db17-ec11-b6e5-000d3a1c2943",
        "NH": "f4f2b237-db17-ec11-b6e5-000d3a1c2943",
        "NJ": "f6f2b237-db17-ec11-b6e5-000d3a1c2943",
        "NM": "f8f2b237-db17-ec11-b6e5-000d3a1c2943",
        "NY": "faf2b237-db17-ec11-b6e5-000d3a1c2943",
        "NC": "fcf2b237-db17-ec11-b6e5-000d3a1c2943",
        "ND": "fef2b237-db17-ec11-b6e5-000d3a1c2943",
        "MP": "00f3b237-db17-ec11-b6e5-000d3a1c2943",
        "OH": "02f3b237-db17-ec11-b6e5-000d3a1c2943",
        "OK": "04f3b237-db17-ec11-b6e5-000d3a1c2943",
        "OR": "06f3b237-db17-ec11-b6e5-000d3a1c2943",
        "PA": "08f3b237-db17-ec11-b6e5-000d3a1c2943",
        "PR": "0af3b237-db17-ec11-b6e5-000d3a1c2943",
        "RI": "0cf3b237-db17-ec11-b6e5-000d3a1c2943",
        "SC": "0ef3b237-db17-ec11-b6e5-000d3a1c2943",
        "SD": "10f3b237-db17-ec11-b6e5-000d3a1c2943",
        "TN": "12f3b237-db17-ec11-b6e5-000d3a1c2943",
        "TX": "14f3b237-db17-ec11-b6e5-000d3a1c2943",
        "UM": "16f3b237-db17-ec11-b6e5-000d3a1c2943",
        "UT": "18f3b237-db17-ec11-b6e5-000d3a1c2943",
        "VT": "1af3b237-db17-ec11-b6e5-000d3a1c2943",
        "VI": "1cf3b237-db17-ec11-b6e5-000d3a1c2943",
        "VA": "1ef3b237-db17-ec11-b6e5-000d3a1c2943",
        "WA": "20f3b237-db17-ec11-b6e5-000d3a1c2943",
        "WV": "22f3b237-db17-ec11-b6e5-000d3a1c2943",
        "WI": "24f3b237-db17-ec11-b6e5-000d3a1c2943",
        "WY": "26f3b237-db17-ec11-b6e5-000d3a1c2943"
    },
    ca: {
        "AB": "7fdab237-db17-ec11-b6e5-000d3a1c2943",
        "BC": "81dab237-db17-ec11-b6e5-000d3a1c2943",
        "MB": "83dab237-db17-ec11-b6e5-000d3a1c2943",
        "NB": "85dab237-db17-ec11-b6e5-000d3a1c2943",
        "NL": "87dab237-db17-ec11-b6e5-000d3a1c2943",
        "NT": "89dab237-db17-ec11-b6e5-000d3a1c2943",
        "NS": "8bdab237-db17-ec11-b6e5-000d3a1c2943",
        "NU": "8ddab237-db17-ec11-b6e5-000d3a1c2943",
        "ON": "8fdab237-db17-ec11-b6e5-000d3a1c2943",
        "PE": "91dab237-db17-ec11-b6e5-000d3a1c2943",
        "QC": "93dab237-db17-ec11-b6e5-000d3a1c2943",
        "SK": "95dab237-db17-ec11-b6e5-000d3a1c2943",
        "YT": "97dab237-db17-ec11-b6e5-000d3a1c2943"
    },
    au: {
        "ACT": "20d7b237-db17-ec11-b6e5-000d3a1c2943",
        "NSW": "22d7b237-db17-ec11-b6e5-000d3a1c2943",
        "NT": "24d7b237-db17-ec11-b6e5-000d3a1c2943",
        "QLD": "26d7b237-db17-ec11-b6e5-000d3a1c2943",
        "SA": "28d7b237-db17-ec11-b6e5-000d3a1c2943",
        "TAS": "2ad7b237-db17-ec11-b6e5-000d3a1c2943",
        "VIC": "2cd7b237-db17-ec11-b6e5-000d3a1c2943",
        "WA": "2ed7b237-db17-ec11-b6e5-000d3a1c2943"
    },
    nz: {
        "AUK": "aae8b237-db17-ec11-b6e5-000d3a1c2943",
        "BOP": "ace8b237-db17-ec11-b6e5-000d3a1c2943",
        "CAN": "aee8b237-db17-ec11-b6e5-000d3a1c2943",
        "CIT": "b0e8b237-db17-ec11-b6e5-000d3a1c2943",
        "GIS": "b2e8b237-db17-ec11-b6e5-000d3a1c2943",
        "HKB": "b4e8b237-db17-ec11-b6e5-000d3a1c2943",
        "MWT": "b6e8b237-db17-ec11-b6e5-000d3a1c2943",
        "MBH": "b8e8b237-db17-ec11-b6e5-000d3a1c2943",
        "NSN": "bae8b237-db17-ec11-b6e5-000d3a1c2943",
        "NTL": "bce8b237-db17-ec11-b6e5-000d3a1c2943",
        "OTA": "bee8b237-db17-ec11-b6e5-000d3a1c2943",
        "STL": "c0e8b237-db17-ec11-b6e5-000d3a1c2943",
        "TKI": "c2e8b237-db17-ec11-b6e5-000d3a1c2943",
        "TAS": "c4e8b237-db17-ec11-b6e5-000d3a1c2943",
        "WGN": "c6e8b237-db17-ec11-b6e5-000d3a1c2943",
        "WTC": "c8e8b237-db17-ec11-b6e5-000d3a1c2943"
    },
    cn: {
        "34": "1ddbb237-db17-ec11-b6e5-000d3a1c2943",// Anhui
        "92": "1fdbb237-db17-ec11-b6e5-000d3a1c2943",// Aomen
        "11": "21dbb237-db17-ec11-b6e5-000d3a1c2943",// Beijing
        "50": "23dbb237-db17-ec11-b6e5-000d3a1c2943",// Chongqing
        "35": "25dbb237-db17-ec11-b6e5-000d3a1c2943",// Fujian
        "62": "27dbb237-db17-ec11-b6e5-000d3a1c2943",// Gansu
        "44": "29dbb237-db17-ec11-b6e5-000d3a1c2943",// Guangdong
        "45": "2bdbb237-db17-ec11-b6e5-000d3a1c2943",// Guangxi
        "52": "2ddbb237-db17-ec11-b6e5-000d3a1c2943",// Guizhou
        "46": "2fdbb237-db17-ec11-b6e5-000d3a1c2943",// Hainan
        "13": "31dbb237-db17-ec11-b6e5-000d3a1c2943",// Hebei
        "23": "33dbb237-db17-ec11-b6e5-000d3a1c2943",// Heilongjiang
        "41": "35dbb237-db17-ec11-b6e5-000d3a1c2943",// Henan
        "42": "37dbb237-db17-ec11-b6e5-000d3a1c2943",// Hubei
        "43": "39dbb237-db17-ec11-b6e5-000d3a1c2943",// Hunan
        "32": "3bdbb237-db17-ec11-b6e5-000d3a1c2943",// Jiangsu
        "36": "3ddbb237-db17-ec11-b6e5-000d3a1c2943",// Jiangxi
        "22": "3fdbb237-db17-ec11-b6e5-000d3a1c2943",// Jilin
        "21": "41dbb237-db17-ec11-b6e5-000d3a1c2943",// Liaoning
        "15": "43dbb237-db17-ec11-b6e5-000d3a1c2943",// NeiMongol
        "64": "45dbb237-db17-ec11-b6e5-000d3a1c2943",// Ningxia
        "63": "47dbb237-db17-ec11-b6e5-000d3a1c2943",// Qinghai
        "37": "49dbb237-db17-ec11-b6e5-000d3a1c2943",// Shandong
        "31": "4bdbb237-db17-ec11-b6e5-000d3a1c2943",// Shanghai
        "14": "4ddbb237-db17-ec11-b6e5-000d3a1c2943",// Shanxi
        "51": "4fdbb237-db17-ec11-b6e5-000d3a1c2943",// Sichuan
        "71": "51dbb237-db17-ec11-b6e5-000d3a1c2943",// Taiwan
        "12": "53dbb237-db17-ec11-b6e5-000d3a1c2943",// Tianjin
        "91": "55dbb237-db17-ec11-b6e5-000d3a1c2943",// Xianggang
        "65": "57dbb237-db17-ec11-b6e5-000d3a1c2943",// Xinjiang
        "54": "59dbb237-db17-ec11-b6e5-000d3a1c2943",// Xizang
        "53": "5bdbb237-db17-ec11-b6e5-000d3a1c2943",// Yunnan
        "33": "5ddbb237-db17-ec11-b6e5-000d3a1c2943" // Zhejiang
    }
};